// extracted by mini-css-extract-plugin
module.exports = {"container":"candidateCard_container__artuF","ListBodyContainer":"candidateCard_ListBodyContainer__1eP7d","jobTitleSelect":"candidateCard_jobTitleSelect__22mKs"};